/**
 * Created by wjjn3481 on 2017/6/13.
 */

export default {
    methods: {
        // 重置表单，特别是在编辑已验证状态切成显示（非编辑）状态
        resetForm (formName) {
            this.$refs[formName] && this.$refs[formName].resetFields()
        },
        submitForm (formName, boolean) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.saveForm(boolean)
                } else {
                    console.log('Not Valid')
                }
            })
        },
        // default save action
        saveForm (boolean) {}
    }
}


// WEBPACK FOOTER //
// ./src/mixins/formCommonMixin.js